import script from "./404View.vue?vue&type=script&setup=true&lang=js"
export * from "./404View.vue?vue&type=script&setup=true&lang=js"

import "./404View.vue?vue&type=style&index=0&id=3d35c696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d35c696"]])

export default __exports__